import React, { FC, useState, useEffect, useMemo, useRef } from "react";
import { Row, Col, Input, Form, Select, Button, Checkbox, Slider } from "antd";
import { QuestionaireType } from "../../constants/enums";
import _ from "lodash";


const RenderFields: FC<{
  activeType?: any;
  item?: any;
  setItem?: any;
  choiceCount?: any;
  setChoiceCount?: any;
  currencyCodeList?: any;
}> = ({
  activeType,
  item,
  setItem,
  choiceCount,
  setChoiceCount,
  currencyCodeList,
}) => {
  let renderEle: any = "";
  switch (activeType) {
    case QuestionaireType.ThreeButton:
      renderEle = (
        <Row className="tiles">
          <Col span={24}>
            <Row className="d-flex mb-4">
              <Col span={12} className="pr-2">
                <Button className="beam-btn green-btn cover w-full">
                  <Input className="beam-input t-white" placeholder="Yes" />
                </Button>
              </Col>
              <Col span={12} className="pl-2">
                <Button className="beam-btn w-full">
                  <Input className="beam-input" placeholder="Maybe" />
                </Button>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Button className="beam-btn orange-btn cover w-full">
                  <Input className="beam-input t-white" placeholder="No" />
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      );
      break;
    case QuestionaireType.YesNo:
      renderEle = (
        <Row className="tiles">
          <Col span={24}>
            <Row className="d-flex mb-4">
              <Col span={12} className="pr-2">
                <Button className="beam-btn green-btn cover w-full">
                  <Input className="beam-input t-white" placeholder="Yes" />
                </Button>
              </Col>
              <Col span={12} className="pl-2">
                <Button
                  className="beam-btn orange-btn cover w-full"
                  key="yes-no"
                >
                  <Input className="beam-input t-white" placeholder="No" />
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      );
      break;
    case QuestionaireType.Capture:
      renderEle = (
        <Row className="tiles">
          <Col span={24} className="d-flex">
            <Checkbox
              className="mb-2"
              checked={item.value === "image"}
              defaultChecked={false}
              onChange={(e) => setItem({ ...item, value: "image" })}
            >
              Image
            </Checkbox>
            <Checkbox
              className="mb-2"
              checked={item.value === "audio"}
              defaultChecked={false}
              onChange={(e) => setItem({ ...item, value: "audio" })}
            >
              Audio
            </Checkbox>
            <Checkbox
              className="mb-2"
              checked={item.value === "video"}
              defaultChecked={false}
              onChange={(e) => setItem({ ...item, value: "video" })}
            >
              Video
            </Checkbox>
          </Col>
        </Row>
      );
      break;
    case QuestionaireType.MultipleChoice:
    case QuestionaireType.Search:
      renderEle = (
        <Row className="tiles">
          <Checkbox
            className="mb-2"
            checked={item.isMulti}
            defaultChecked={false}
            onChange={(e) => setItem({ ...item, isMulti: e.target.checked })}
          >
            MultiSelect
          </Checkbox>
          {_.times(choiceCount, (i) => {
            return (
              <Col span={24} key={i} className="mb-3">
                <Input
                  value={item.options[i]}
                  className="beam-input"
                  onChange={(e) => {
                    const options = item.options;
                    options[i] = e.target.value;
                    setItem({
                      ...item,
                      options,
                    });
                  }}
                />
              </Col>
            );
          })}
          <Col span={24} className="t-right">
            <Button
              className="beam-btn"
              onClick={() => {
                setChoiceCount(choiceCount + 1);
                const options: any = item.options;
                options.push("");
                setItem({
                  ...item,
                  options: options,
                });
              }}
            >
              Add
            </Button>
          </Col>
        </Row>
      );
      break;

    case QuestionaireType.Text:
      renderEle = (
        <Row className="tiles">
          <Checkbox
            className="mb-2"
            checked={item.isMulti}
            defaultChecked={false}
            onChange={(e) => setItem({ ...item, isMulti: e.target.checked })}
          >
            Multiline?
          </Checkbox>
        </Row>
      );
      break;

    case QuestionaireType.Bar:
      renderEle = (
        <Row
          style={{ height: "240px" }}
          className="tiles d-flex justify-content-center"
        >
          <div className="slider ml-3 mr-3">
            <Slider
              vertical
              defaultValue={40}
              onChange={(value) => {
                const options = item.options;
                if (!options.length) {
                  options.push(value);
                }
                options[0] = value;
                setItem({
                  ...item,
                  options,
                });
              }}
            />
            <h5>MAX</h5>
          </div>
          <div className="slider ml-3 mr-3">
            <Slider
              vertical
              defaultValue={30}
              onChange={(value) => {
                const options = item.options;
                if (!options.length) {
                  options.push(40);
                  options.push(value);
                }
                options[1] = value;
                setItem({
                  ...item,
                  options,
                });
              }}
            />
            <h5>MIN</h5>
          </div>
          <div className="slider ml-3 mr-3">
            <Slider
              vertical
              defaultValue={5}
              onChange={(value) => {
                const options = item.options;
                if (!options.length) {
                  options.push(40);
                  options.push(30);
                  options.push(value);
                }
                options[2] = value;
                setItem({
                  ...item,
                  options,
                });
              }}
            />
            <h5>STEP</h5>
          </div>
        </Row>
      );
      break;
    case QuestionaireType.Currency:
      renderEle = (
        <Row>
          <Select
            value={item.options[0]}
            onChange={(value) => {
              const enterValue: any = value;
              setItem({
                ...item,
                options: [enterValue],
              });
            }}
            className="w-full"
            placeholder="Select Currency"
            options={currencyCodeList}
          ></Select>
        </Row>
      );

      break;
    default:
      renderEle = "";
  }
  return renderEle;
};

export default RenderFields;
